import jsPDF from 'jspdf';

const PAGE_W = 210;
const PAGE_H = 297;
const M = 16;
const FOOTER_Y = 286;

function safeText(value) {
  return String(value || '').replace(/[–—]/g, '-').replace(/[“”]/g, '"').replace(/[‘’]/g, "'");
}

function drawTemplate(doc, pageNumber, title) {
  doc.setFillColor(9, 30, 55);
  doc.rect(0, 0, PAGE_W, 28, 'F');
  doc.setFillColor(0, 117, 190);
  doc.roundedRect(M, 7, 15, 15, 2, 2, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('ST', M + 7.5, 16.5, { align: 'center' });
  doc.setFontSize(13);
  doc.text('SALAR TECHNOLOGIES LLC', M + 20, 12);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7.5);
  doc.text('ENGINEERING THE FUTURE | AMERICAN GRIT. ADVANCED SYSTEMS.', M + 20, 17);
  doc.text('salartechnologies.com', M + 20, 22);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.text('Patent Demo Export', PAGE_W - M, 12, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.text(safeText(title).slice(0, 62), PAGE_W - M, 18, { align: 'right' });

  doc.setDrawColor(0, 117, 190);
  doc.setLineWidth(0.4);
  doc.line(M, 32, PAGE_W - M, 32);

  doc.setDrawColor(130, 180, 220);
  doc.setLineWidth(0.2);
  doc.line(M, FOOTER_Y, PAGE_W - M, FOOTER_Y);
  doc.setTextColor(25, 55, 85);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text('SALAR Technologies LLC | salartechnologies.com | contact@salartechnologies.com | vikrant@salartechnologies.com', M, FOOTER_Y + 5);
  doc.text(`Page ${pageNumber}`, PAGE_W - M, FOOTER_Y + 5, { align: 'right' });
  doc.setDrawColor(0, 117, 190);
  doc.rect(PAGE_W - M - 14, FOOTER_Y - 15, 14, 14);
  doc.setFontSize(5.5);
  doc.text('QR', PAGE_W - M - 7, FOOTER_Y - 7, { align: 'center' });
}

function addPageIfNeeded(doc, state, needed = 22, title = '') {
  if (state.y + needed > FOOTER_Y - 6) {
    doc.addPage();
    state.page += 1;
    drawTemplate(doc, state.page, title);
    state.y = 40;
  }
}

function sectionTitle(doc, state, text, title) {
  addPageIfNeeded(doc, state, 12, title);
  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text(safeText(text), M, state.y);
  state.y += 5;
  doc.setDrawColor(0, 117, 190);
  doc.line(M, state.y, PAGE_W - M, state.y);
  state.y += 5;
}

function paragraph(doc, state, text, title, options = {}) {
  const size = options.size || 9;
  const indent = options.indent || 0;
  const width = PAGE_W - 2 * M - indent;
  doc.setTextColor(options.color?.[0] || 30, options.color?.[1] || 50, options.color?.[2] || 72);
  doc.setFont('helvetica', options.bold ? 'bold' : 'normal');
  doc.setFontSize(size);
  const lines = doc.splitTextToSize(safeText(text), width);
  addPageIfNeeded(doc, state, lines.length * (size * 0.42) + 4, title);
  doc.text(lines, M + indent, state.y);
  state.y += lines.length * (size * 0.42) + 4;
}

function keyValue(doc, state, key, value, title) {
  addPageIfNeeded(doc, state, 9, title);
  doc.setFontSize(8);
  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.text(safeText(key), M, state.y);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(30, 50, 72);
  const lines = doc.splitTextToSize(safeText(value), 118);
  doc.text(lines, M + 58, state.y);
  state.y += Math.max(6, lines.length * 4.2 + 2);
}

function drawCaseBox(doc, state, heading, body, title, good = true) {
  addPageIfNeeded(doc, state, 34, title);
  const x = M;
  const y = state.y;
  const w = PAGE_W - 2 * M;
  const fill = good ? [232, 249, 244] : [255, 238, 238];
  const stroke = good ? [20, 184, 166] : [239, 68, 68];
  doc.setFillColor(...fill);
  doc.setDrawColor(...stroke);
  doc.roundedRect(x, y, w, 31, 2, 2, 'FD');
  doc.setTextColor(good ? 0 : 120, good ? 95 : 20, good ? 85 : 20);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text(safeText(heading), x + 4, y + 7);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7.6);
  doc.setTextColor(30, 50, 72);
  const lines = doc.splitTextToSize(safeText(body), w - 8);
  doc.text(lines.slice(0, 5), x + 4, y + 13);
  state.y += 37;
}

function addPatentBrief(doc, meta, state) {
  const title = `${meta.title} | ${meta.appNum}`;
  if (state.started) {
    doc.addPage();
    state.page += 1;
  }
  state.started = true;
  drawTemplate(doc, state.page, title);
  state.y = 42;

  doc.setTextColor(9, 30, 55);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(19);
  doc.text(`P${meta.index}. ${safeText(meta.title)}`, M, state.y);
  state.y += 8;
  doc.setFontSize(10);
  doc.setTextColor(0, 117, 190);
  doc.text(safeText(`${meta.appNum} | ${meta.status}`), M, state.y);
  state.y += 9;
  paragraph(doc, state, meta.headline, title, { size: 10, bold: true, color: [9, 30, 55] });
  paragraph(doc, state, meta.subheadline, title, { size: 8.8 });

  sectionTitle(doc, state, '1. Requirement / customer problem', title);
  paragraph(doc, state, meta.requirement, title);

  sectionTitle(doc, state, '2. Patent verbiage definition - public-safe', title);
  paragraph(doc, state, meta.patentDefinition, title);

  sectionTitle(doc, state, '3. Why it is relevant', title);
  paragraph(doc, state, meta.relevance, title);

  sectionTitle(doc, state, '4. Problem-to-method explanation', title);
  keyValue(doc, state, 'Problem', meta.problem, title);
  keyValue(doc, state, 'SALAR method', meta.solution, title);
  keyValue(doc, state, 'Demo meaning', meta.demoMeaning, title);

  sectionTitle(doc, state, '5. Best case / bad case interpretation', title);
  drawCaseBox(doc, state, meta.goodCaseTitle, meta.goodCase, title, true);
  drawCaseBox(doc, state, meta.badCaseTitle, meta.badCase, title, false);

  sectionTitle(doc, state, '6. What this achievement shows', title);
  paragraph(doc, state, meta.achievement, title);

  sectionTitle(doc, state, '7. Buyer / reviewer fit', title);
  paragraph(doc, state, `Best-fit reviewers: ${meta.targetBuyers.split('|').join(', ')}.`, title);
  paragraph(doc, state, `Public demo route: https://www.salartechnologies.com/patent-demos/${meta.slug}`, title, { size: 8 });
  paragraph(doc, state, 'Disclosure note: This export is a public-safe explanatory brief. It does not disclose non-public claim charts, source code, confidential implementation details, customer data, or any government endorsement.', title, { size: 7.5 });
}

export function generatePatentDemoPdf(meta) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const state = { page: 1, y: 40, started: false };
  addPatentBrief(doc, meta, state);
  doc.save(`SALAR_P${meta.index}_${meta.slug}_Demo_Brief.pdf`);
}

export function generateAllPatentDemoPdf(patents) {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const state = { page: 1, y: 40, started: false };
  patents.forEach((meta) => addPatentBrief(doc, meta, state));
  doc.save('SALAR_All_9_Patent_Demo_Briefs.pdf');
}
